var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"role":"presentation","fill":"none"}},[_c('rect',{attrs:{"x":"4","y":"4","width":"16","height":"16","stroke":"currentColor","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }